/* 🤖 this file was generated by script */
export const wiconReceiptCheck = {
  name: 'receipt_check',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 10.5l2 2L15.5 8M20 21V7.8c0-1.68 0-2.52-.33-3.16a3 3 0 00-1.3-1.31C17.71 3 16.87 3 15.2 3H8.8c-1.68 0-2.52 0-3.16.33a3 3 0 00-1.31 1.3C4 5.29 4 6.13 4 7.8V21l2.75-2 2.5 2L12 19l2.75 2 2.5-2L20 21z"/></svg>`,
};
